import { css } from 'styled-components';

const InputDatepickerWrapper = css`
  max-width: 100%;
  width: 100%;
  margin: 5px 0px;
  .rdrSelected {
    background-color: #BBEDF8 !important;
    border-radius: 0;
  }

  .rdrSelected + .rdrDayStartPreview.rdrDayEndPreview {
    border: 0;
  }

  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: #657480 !important;
  }

  .rdrWeekDay {
    color: #8295A3;
  }

  .rdrCalendarWrapper {
    max-width: 100%;
    width: 100%;
  }
  .rdrMonthAndYearWrapper {
    align-items: center;
    height: 35px;
    padding-top: 0;
    border: 0;
    border-bottom: 1px solid #E6E7E8;
  }

  .rdrYearPicker {
    display: none;
  }

  .rdrNextPrevButton {
    width: 24px;
    height: 24px;
    margin: 0 0.833em;
    padding: 0;
    border: 0;
    border-radius: 50px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rdrNextPrevButton.rdrPprevButton {
    &:after {
      border-style: solid;
      border-width: 0 3px 3px 0;
      content: '';
      position: relative;
      padding: 3px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      vertical-align: middle;
      color: #278ECD;
      -webkit-trans7orm: rotate(135deg);
      -ms-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    i {
      display: none;
    }
  }

  .rdrNextButton {
    &:after {
      border-style: solid;
      border-width: 0 3px 3px 0;
      content: '';
      position: relative;
      padding: 3px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      vertical-align: middle;
      color: #278ECD;
      -webkit-trans7orm: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }

  .rdrNextButton i {
    display: none;
  }

  .rdrDayEndOfMonth .rdrDayInPreview, .rdrDayEndOfMonth .rdrDayStartPreview, .rdrDayEndOfWeek .rdrDayInPreview, .rdrDayEndOfWeek .rdrDayStartPreview{
    border-radius: 0;
    border: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0px;
  }

  .rdrDayStartOfMonth .rdrDayInPreview, .rdrDayStartOfMonth .rdrDayEndPreview, .rdrDayStartOfWeek .rdrDayInPreview, .rdrDayStartOfWeek .rdrDayEndPreview{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0px;
    left: 0px;
    border: 0;
  }

  .rdrDayNumber {
    font-weight: 600;
    color: #657480;
  }

  .rdrInRange + .rdrDayNumber {
    span {
      color: #560C56 !important;
    }
  }

  .rdrMonthAndYearPickers select {
    color: #278ECD;
    font-weight: 700;
    padding: 10px;
    font-size: 14px;
    text-align-last: center;
    text-transform: capitalize;
    background: transparent;
  }

  .rdrDateDisplayWrapper {
    display: none;
  }

  .rdrMonth {
    max-width: 100%;
    width: 100%;
  }

  .rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after {
    border: 0 !important;
  }

  .rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after {
    border: 0 !important;
  }

  .rdrDayStartPreview, .rdrDayInPreview, .rdrDayEndPreview {
    border: 0;
  }
`;

export default InputDatepickerWrapper;
